<template>
    <b-modal v-model="show" title="ПАРАМЕТЕР" class="cadastre-building" :no-close-on-esc="true"
             :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Номи <span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.name"
                                :class="{'is-invalid': $v.data.name.$error}"
                                @blur="$v.data.name.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.name.$error">{{$t("realEstate.validation.cadastreBuildingFieldReferenceEdit.nameUz")}}</div>
                    </div>

                    <div class="form-group">
                        <label>Бино тури <span class="red">*</span></label>
                        <v-select v-model="category"
                                  label="name"
                                  :options="categories"
                                  :filterable="false"
                                  @search:focus="onCategory"
                                  :class="{invalid : $v.category.$error}"
                        >
                            <template slot="option" slot-scope="option" v-if="option && option.name">
                                <div v-html="option.name"></div>
                            </template>
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label>Қўшимча параметерлар (Ички референслар учун)</label>
                        <div class="table-responsive">
                            <div class="table-wrapper">
                              <table class="table table-striped">
                                  <thead>
                                  <tr>
                                      <th width="100%">Номи</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                    <template v-if="childFields && childFields.length > 0">
                                        <tr v-for="field in childFields" :key="field.id">
                                            <td style="vertical-align: top">
                                                <input type="text" class="form-control" v-model="field.name"/>
                                            </td>
                                        </tr>
                                    </template>
                                    <tr>
                                        <td>
                                            <button class="all-btn add-btn" @click="addField">Қўшиш</button>
                                        </td>
                                    </tr>
                                  </tbody>
                              </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import {numericTypes} from '@/shared/constants/mask'
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {clone} from '@/shared/utils';
    import initFilterModel from '@/shared/filter';
    import {required} from 'vuelidate/lib/validators'
    import AdvancedFilter from '@/shared/filters/advancedFilter';

    export default {
        name: "PurposesRentingAreasAddEditModal",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                numericTypes: numericTypes,
                parentFilter: initFilterModel(),
                filterBuildingType: new AdvancedFilter(),
                data: this.initEmptyData(),
                childFields: [],
                categories: [],
                category: null
            }
        },
        validations () {
            return {
                category: {
                    required: required
                },
                data: {
                    name: {
                        required: required
                    }
                }
            }
        },
        methods: {
            initEmptyData() {
                return {
                    name: '',
                    category: null
                }
            },
            addField() {
                this.childFields.push({
                    name: '',
                });
            },
            cancel() {
                this.show = false;
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                this.processing = true;
                this.data.childFields = {};
                if (this.childFields && this.childFields.length > 0) {
                    this.data.childFields = this.childFields.filter((field) => {
                        return field.name && field.name.length > 0;
                    });
                }
                this.data.category = this.category.code;
                this.$http.post('rental-rates/purposes-renting-areas/save', this.data)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('purposesRentingAreasChanged', response);
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            },
            onCategory() {
                this.filterBuildingType.onlyParentLookUp = true
                this.$http.post('building-type/list', this.filterBuildingType)
                    .then(res => {
                        this.categories = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            }
        },
        created() {
            this.parentFilter.page.size = 1000;
            this.$eventBus.$on('showPurposesRentingAreasAddEditModal', (data) => {
                this.childFields = [];
                if (data) {
                    this.data = clone(data);
                } else {
                    this.data = this.initEmptyData();
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>
